import * as request from "superagent";
import { APIError, IDAttribute, NumberAttribute, StringAttribute, ObjectAttribute, DateTimeAttribute } from "../types"
import {without} from "lodash"

const defaultApiUrl = "/api/portal-user-subscriptions"

export class PortalUserSubscription {

  static get = (id:number, resourceUrl?:string):Promise<PortalUserSubscription> => {
    if(!resourceUrl) {
      resourceUrl = defaultApiUrl
    }
    let p = new Promise<PortalUserSubscription>((resolve,reject) => {
      //Perform get here
      request.get(resourceUrl + "/" + id.toString()).then((response)=>{
        if(!response.ok){
          const apiErr = new APIError()
          apiErr.type = "api"
          apiErr.message = response.body.toString()
          reject(apiErr)
        } else {
          resolve(new PortalUserSubscription(response.body))
        }
      }).catch((err)=>{
        const apiErr = new APIError()
        apiErr.type = "http"
        apiErr.message = (err.response || {text: err.toString()}).text
        reject(apiErr)
      })
    });

    p.catch((err:any)=>{
        if (err.message && err.message == "Unauthorized") {
            // If our session times out, ask the user to login again, rather than failing until they figure out to refresh
            window.location.href = "/login"
        }
    })

    return p 
  }

  static query = (q:any, resourceUrl?:string):Promise<Array<PortalUserSubscription>> => {
    if(!resourceUrl) {
      resourceUrl = defaultApiUrl
    }
    resourceUrl += "?filter=" + encodeURIComponent(JSON.stringify(q))
    let p = new Promise<Array<PortalUserSubscription>>((resolve,reject) => {
      //Perform query here
      request.get(resourceUrl as string).then((response)=>{
        if(!response.ok){
          const apiErr = new APIError()
          apiErr.type = "api"
          apiErr.message = response.body.toString()
          reject(apiErr)
        } else {
          const data = new Array<PortalUserSubscription>()
          if(response.body){
            for (var i of response.body) {
                data.push(new PortalUserSubscription(i))
            }
          }
          resolve(data)
        }
      }).catch((err)=>{
        const apiErr = new APIError()
        apiErr.type = "http"
        apiErr.message = (err.response || {text: err.toString()}).text
        reject(apiErr)
      })
    });

    p.catch((err:any)=>{
        if (err.message && err.message == "Unauthorized") {
            // If our session times out, ask the user to login again, rather than failing until they figure out to refresh
            window.location.href = "/login"
        }
    })

    return p 
  }

  // Model Attributes
 
  id: IDAttribute;  
  portalUserID: NumberAttribute; 
  portalAuthTokenID: NumberAttribute; 
  name: StringAttribute;  
  cron: StringAttribute;  
  subject: StringAttribute;  
  template: StringAttribute;  
  dataURL: StringAttribute;  
  extendedAttributes: ObjectAttribute;  
  lastRunDt: DateTimeAttribute;  
  lastRunError: StringAttribute;  
  nextRunDt: DateTimeAttribute;  
  createdAt: DateTimeAttribute;  
  createdBy: StringAttribute;  
  updatedAt: DateTimeAttribute;  
  updatedBy: StringAttribute; 
  status: StringAttribute;  
  _transactionQueue: Array<Promise<PortalUserSubscription>>;

  constructor(data?:any) { 
    if(!data){
        data = {}
    }
     
    this.id= new IDAttribute(data.id);  
    this.portalUserID = new NumberAttribute(data.portalUserID); 
    this.portalAuthTokenID = new NumberAttribute(data.portalAuthTokenID); 
    this.name = new StringAttribute(data.name);  
    this.cron = new StringAttribute(data.cron);  
    this.subject = new StringAttribute(data.subject);  
    this.template = new StringAttribute(data.template);  
    this.dataURL = new StringAttribute(data.dataURL);  
    this.extendedAttributes = new ObjectAttribute(data.extendedAttributes ? data.extendedAttributes : {});  
    this.lastRunDt = new DateTimeAttribute(data.lastRunDt);  
    this.lastRunError = new StringAttribute(data.lastRunError);  
    this.nextRunDt = new DateTimeAttribute(data.nextRunDt);  
    this.status = new StringAttribute(data.status);  
    this.createdAt = new DateTimeAttribute(data.createdAt);  
    this.createdBy = new StringAttribute(data.createdBy);  
    this.updatedAt = new DateTimeAttribute(data.updatedAt);  
    this.updatedBy = new StringAttribute(data.updatedBy); 
    
    this._transactionQueue = new Array<Promise<PortalUserSubscription>>();
  }

  get modelData():any{
      return this.getModelData()
  }

  public getModelData():any {
    var d:any = {}  
    if(this.id) {
      d.id = this.id.value
    }
     
    if(this.portalUserID) {
      d.portalUserID = this.portalUserID.value
    }
     
    if(this.portalAuthTokenID) {
      d.portalAuthTokenID = this.portalAuthTokenID.value
    }
     
    if(this.name) {
      d.name = this.name.value
    }
     
    if(this.cron) {
      d.cron = this.cron.value
    }
     
    if(this.subject) {
      d.subject = this.subject.value
    }
     
    if(this.template) {
      d.template = this.template.value
    }
     
    if(this.dataURL) {
      d.dataURL = this.dataURL.value
    }
     
    if(this.extendedAttributes) {
      d.extendedAttributes = this.extendedAttributes.value
    }
     
    if(this.lastRunDt) {
      d.lastRunDt = this.lastRunDt.value
    }
     
    if(this.lastRunError) {
      d.lastRunError = this.lastRunError.value
    }
     
    if(this.nextRunDt) {
      d.nextRunDt = this.nextRunDt.value
    }

    if(this.status) {
      d.status = this.status.value
    }
     
    if(this.createdAt) {
      d.createdAt = this.createdAt.value
    }
     
    if(this.createdBy) {
      d.createdBy = this.createdBy.value
    }
     
    if(this.updatedAt) {
      d.updatedAt = this.updatedAt.value
    }
     
    if(this.updatedBy) {
      d.updatedBy = this.updatedBy.value
    }
    

    return d
  }

  validate = ():Promise<boolean> => {
    return new Promise((resolve,reject) => {
      //Perform validation here
    });
  }

  save = (resourceUrl?:string):Promise<PortalUserSubscription> => {
    var self = this
    let pFn = (resolve:any,reject:any) => {
      if(!resourceUrl) {
        resourceUrl = defaultApiUrl
      }
      // TODO: jdouglas Add validations to generator Tue Dec 12 09:58:59 2017


      if(!self.id.value){


        request.post(resourceUrl).send(self.modelData).then((response)=>{

          // we should never get text/html unless we are getting redirected to login by the server
          if(response.type === "text/html"){
            window.location.href = "/login"
          }
          
          if(!response.ok){
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = response.body.toString()
            reject(apiErr)
          } else {


            this.id.value = response.body.id
 
              
            resolve(new PortalUserSubscription(response.body))
          }
        }).catch((err:any)=>{
           const apiErr = new APIError()
            apiErr.type = "http"
            apiErr.message = (err.response || {text: err.toString()}).text
            reject(apiErr)
        })
      } else {

        request.put(resourceUrl + "/" + this.id.toString()).send(this.modelData).then((response)=>{


          if(!response.ok){
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = response.body.toString()
            reject(apiErr)
          } else {
            
            resolve(new PortalUserSubscription(response.body))
          }
        }).catch((err:any)=>{
           const apiErr = new APIError()
            apiErr.type = "http"
            apiErr.message = (err.response || {text: err.toString()}).text
            reject(apiErr)
        })
      }
    }
    
    var p:Promise<PortalUserSubscription>

    if(self._transactionQueue.length == 0){
        //console.log("Stack Empty")
        // If there are not outstanding transactions, just go ahead and create the promise
        // with pFn, adding the reject/resolve code to remove the item from the list.
        p = new Promise(pFn)

    } else {

        //console.log("Stack has " + self._transactionQueue.length + " items")
        const lastItem =self._transactionQueue[self._transactionQueue.length -1 ]
        // If there are outstanding transactions, listen for the completion of the last one, prior to initiating self one.
        p = new Promise((resolve, reject) => {
            lastItem.then((result:any) => {
                pFn(resolve, reject)
            }).catch((reason:any) => {
                pFn(resolve, reject)
            })
        })

    }

    self._transactionQueue.push(p)
    //console.log("Stack raised to " + self._transactionQueue.length + " items")

    // self is where we will recognize that a promise has concluded and remove it from the queue
    p.then(()=>{
        self._transactionQueue = without(self._transactionQueue, p)
        //console.log("Stack reduced to " + self._transactionQueue.length + " items")
    })
    .catch((err:any)=>{
        if (err.message && err.message == "Unauthorized") {
            // If our session times out, ask the user to login again, rather than failing until they figure out to refresh
            window.location.href = "/login"
        }
        self._transactionQueue = without(self._transactionQueue, p)
        //console.log("Stack reduced to " + self._transactionQueue.length + " items")
    })

    return p
    

  }
 
  delete = (resourceUrl?:string):Promise<PortalUserSubscription> => {
    return new Promise((resolve,reject) => {
      if(!resourceUrl) {
        resourceUrl = defaultApiUrl
      }
      // TODO: jdouglas Add validations to generator Tue Dec 12 09:58:59 2017

      if(!this.id.value){

        const apiErr = new APIError()
        apiErr.type = "api"
        apiErr.message = "ID Required to delete"
        reject(apiErr)
      } else {

        request.delete(resourceUrl + "/" + this.id.toString()).send(this.modelData).then((response)=>{

          if(!response.ok){
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = response.body.toString()
            reject(apiErr)
          } else {
            resolve(this)
          }
        }).catch((err:any)=>{
            const apiErr = new APIError()
            apiErr.type = "api"
            apiErr.message = err.message 
            reject(apiErr)
        })
      }
    });
  }

}

export default PortalUserSubscription 
